import { makeColors } from './utils';

export const UTColors = makeColors({
  primary: ['#3187ee', '#3187ee'],
  primaryUp: ['#52A0FF', '#52a0ff'],
  primaryDown: ['#126BD9', '#126bd9'],

  primaryDim: ['rgba(49, 135, 238, 0.1)', 'rgba(49, 135, 238, 0.1)'],
  primaryDimUp: ['rgba(49, 135, 238, 0.2)', 'rgba(49, 135, 238, 0.2)'],
  primaryDimDown: ['rgba(49, 135, 238, 0.3)', 'rgba(49, 135, 238, 0.3)'],
  primaryDimFocus: ['rgba(49, 134, 238, 0.4)', 'rgba(49, 134, 238, 0.4)'],

  warning: ['#FFDF5A', '#ffdf5a'],
  warningUp: ['#FFD527', '#ffd527'],
  warningDown: ['#F8C800', '#f8c800'],

  warningDim: ['rgba(255, 223, 90, 0.3)', 'rgba(255, 223, 90, 0.3)'],
  warningDimUp: ['rgba(255, 223, 90, 0.5)', 'rgba(255, 223, 90, 0.5)'],
  warningDimDown: ['rgba(255, 223, 90, 0.8)', 'rgba(255, 223, 90, 0.8)'],

  alert: ['#ed4040', '#ed4040'],
  alertUp: ['#FF5252', '#ff5252'],
  alertDown: ['#DE3131', '#de3131'],

  alertDim: ['rgba(237, 64, 64, 0.1)', 'rgba(237, 64, 64, 0.15)'],
  alertDimUp: ['rgba(237, 64, 64, 0.15)', 'rgba(237, 64, 64, 0.2)'],
  alertDimDown: ['rgba(237, 64, 64, 0.3)', 'rgba(237, 64, 64, 0.3)'],
  alertDimFocus: ['rgba(237, 64, 64, 0.2)', 'rgba(237, 64, 64, 0.2)'],

  error: ['#ff9113', '#ff9113'],
  errorUp: ['#FFA238', '#ffa238'],
  errorDown: ['#EB8709', '#eb8709'],

  errorDim: ['rgba(255, 145, 19, 0.15)', 'rgba(255, 145, 19, 0.15)'],
  errorDimUp: ['rgba(255, 145, 19, 0.22)', 'rgba(255, 145, 19, 0.22)'],
  errorDimDown: ['rgba(255, 145, 19, 0.35)', 'rgba(255, 145, 19, 0.35)'],

  success: ['#33B327', '#33b327'],
  successUp: ['#42C936', '#42c936'],
  successDown: ['#29A81D', '#29a81d'],

  successDim: ['rgba(51, 179, 39, 0.1)', 'rgba(51, 179, 39, 0.1)'],
  successDimUp: ['rgba(51, 179, 39, 0.2)', 'rgba(51, 179, 39, 0.2)'],
  successDimDown: ['rgba(51, 179, 39, 0.3)', 'rgba(51, 179, 39, 0.3)'],
  successDimFocus: ['rgba(51, 178, 39, 0.4)', 'rgba(51, 178, 39, 0.4)'],

  muted: ['#3a3a3c', '#cfcfd5'],
  mutedUp: ['#535356', '#e5e5e9'],
  mutedDown: ['#262628', '#262626'],

  input: ['rgba(0, 41, 91, 0.06)', 'rgba(199, 202, 206, 0.1)'],
  inputUp: ['rgba(0, 41, 91, 0.09)', 'rgba(199, 202, 206, 0.13)'],
  inputDown: ['rgba(0, 41, 91, 0.12)', 'rgba(199, 202, 206, 0.15)'],
  inputFocus: ['rgba(0, 41, 91, 0.2)', 'rgba(199, 202, 206, 0.2)'],

  scream: ['#004BFF', '#336fff'],
  screamUp: ['#327DFF', '#5795ff'],
  screamDown: ['#002DE1', '#0b3cff'],

  screamDim: ['rgba(0, 75, 255, 0.1)', 'rgba(49, 110, 255, 0.1)'],
  screamDimUp: ['rgba(0, 75, 255, 0.2)', 'rgba(87, 137, 255, 0.2)'],
  screamDimDown: ['rgba(0, 75, 255, 0.3)', 'rgba(28, 95, 255, 0.3)'],
  screamDimFocus: ['rgba(0, 75, 255, 0.4)', 'rgba(28, 95, 255, 0.4)'],

  disabled: ['rgba(0, 0, 0, 0.04)', 'rgba(255, 255, 255, 0.04)'],

  help: ['#D7E2EF', '#363D46'],

  inputRegular: ['rgba(0, 41, 91, 0.06)', ''],
  inputActive: ['rgba(0, 41, 91, 0.1)', ''],

  border30: ['rgba(0, 0, 0, 0.3)', 'rgba(255, 255, 255, 0.3)'],
  border15: ['rgba(0, 0, 0, 0.15)', 'rgba(255, 255, 255, 0.15)'],
  border10: ['rgba(0, 0, 0, 0.1)', 'rgba(255, 255, 255, 0.1)'],
  border5: ['rgba(0, 0, 0, 0.05)', 'rgba(255, 255, 255, 0.05)'],

  shadow10: ['rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)'],

  bgDefault: ['#FFFFFF', '#1a1a1a'],
  bgDefault10: ['rgba(255, 255, 255, 0.1)', 'rgba(0, 0, 0, 0.1)'],
  bgDim: ['#F2F4F6', '#2c2c2c'],
  bgGradientDim: ['rgba(242, 244, 247, 0.0001)', 'rgba(44, 44, 44, 0.0001)'],
  bgUp: ['#FFFFFF', '#333333'],
  bgButtonRegular: ['#ffffff', '#4a4a4a'],
  segmentedDown: ['#ffffff', '#262626'],

  listItemUp: ['rgba(255, 255, 255, 0.05)', 'rgba(0, 0, 0, 0.05)'],
  listItemDown: ['rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)'],
  popupShadow: ['rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)'],

  modalOverlay: ['rgba(0, 0, 20, 0.4)', 'rgba(26, 26, 26, 0.5)'],
  /** Цвет для прозрачности в градиентах с поддержкой safari */
  transparent: ['rgba(255, 255, 255, 0.0001)', 'rgba(0, 0, 0, 0.0001)']
});

export const TXTColors = makeColors({
  default: ['#000000', '#ffffff'],
  defaultDim: ['rgba(0, 0, 0, 0.5)', 'rgba(255, 255, 255, 0.5)'],
  disabled: ['rgba(0, 0, 0, 0.3)', 'rgba(255, 255, 255, 0.3)'],
  inverse: ['#ffffff', '#000000'],
  inverseDim: ['rgba(255, 255, 255, 0.5)', 'rgba(0, 0, 0, 0.5)'],
  primary: ['#0b5acd', '#52a0ff'],
  primaryInverse: ['#52A0FF', '#0b5acd'],
  success: ['#02980e', '#41d14d'],
  alert: ['#d41919', '#ff7878'],
  alertDim: ['rgba(212, 25, 25, 0.2)', 'rgba(212, 25, 25, 0.2)'],
  error: [' #e47a00', '#ffa743'],
  warning: ['#65290D', '#ffdf5a'],
  buttonDefault: ['#ffffff', '#ffffff'],
  buttonInverse: ['#000000', '#000000']
});

export const GraphColors = makeColors({
  up: ['#5495d8', '#5495d8'],
  upDim: ['rgba(80, 134, 200, 0.15)', 'rgba(80, 134, 200, 0.2)'],
  down: ['#e68282', '#e68282'],
  downDim: ['rgba(180, 86, 83, 0.1)', 'rgba(180, 86, 83, 0.15)']
});

export const ScrollColors = makeColors({
  normal: ['rgba(0, 0, 0, 0.1)', 'rgba(255, 255, 255, 0.2)'],
  up: ['rgba(0, 0, 0, 0.2)', 'rgba(255, 255, 255, 0.3)'],
  down: ['rgba(0, 0, 0, 0.3)', 'rgba(255, 255, 255, 0.5)']
});
